
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/funnels",
      function () {
        return require("private-next-pages/funnels/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/funnels"])
      });
    }
  